import React, { useEffect, useState } from "react";
import { FaCheck, FaDiscord } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { CDN_BASE_URL } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";

const DiscordNameTask = ({ user, getData, reward, setuser }) => {
  const [discordLoading, setDiscordLogin] = useState(false);
  const handleDiscordLogin = () => {
    localStorage.setItem("discordName", "true");
    window.location.href = CDN_BASE_URL + "auth/discord";
  };

  useEffect(() => {
    const checkDiscordReturn = async () => {
      setDiscordLogin(true);
      const isReturningFromDiscord = localStorage.getItem("discordName");
      if (isReturningFromDiscord) {
        try {
          const response = await axios.get(
            CDN_BASE_URL + "discord/name/user/" + user?._id,
            {
              withCredentials: true,
            }
          ); // API مورد نظر تو
          setuser(response.data);
          // موفقیت‌آمیز، حالا فلگ را پاک کن
          localStorage.removeItem("discordName");
          // شاید نیاز به رفرش دیتا یا redirect داشته باشی
        } catch (err) {
          localStorage.removeItem("discordName");
        }
      }
      setDiscordLogin(false);
    };

    checkDiscordReturn();
  }, []);

  return (
    <div
      className={`${
        user?.discordname?.isDoes && "order-last opacity-40"
      } flex justify-between gap-3 items-center relative py-2 pb-4 border-b`}
    >
      <span className="flex items-center gap-2 lg:gap-4">
        <FaDiscord className="text-[32px] sm:text-[54px] lg:text-[72px]" />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2">
            Add Filetrust to Discord Name
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />+{reward}{" "}
            daily
          </span>
        </span>
      </span>
      {discordLoading ? (
        <button
          disabled
          className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          Loading...
        </button>
      ) : user?.discordname?.isDoes ? (
        <button
          onClick={handleDiscordLogin}
          disabled={user?.discordname?.isDoes}
          className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          {user?.discordname?.isDoes ? (
            <>
              <FaCheck color="green" /> Claimed
            </>
          ) : (
            "Check"
          )}
        </button>
      ) : (
        <span className="flex flex-wrap gap-2 justify-end">
          <button
            onClick={handleDiscordLogin}
            disabled={user?.discordname?.isDoes}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            {user?.discordname?.isDoes ? (
              <>
                <FaCheck color="green" /> Claimed
              </>
            ) : (
              "Check"
            )}
          </button>
        </span>
      )}
    </div>
  );
};

export default DiscordNameTask;
